import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auto_response: 1,    //自动应答 1开 2关
    loginFlag: 1,        //1登录 2失效
    sip_status: 1,       //1空闲 2忙碌
  },
  mutations: {
    getSipStatus(state,sip_status){
      state.sip_status = sip_status
    },
    getAutoResponse(state,auto_response){
      state.auto_response = auto_response
    },
    getLoginFlag(state,loginFlag){
      state.loginFlag = loginFlag
    }
  },
  getters: {
  },
  actions: {
  },
  modules: {
  }
})
